import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useAppContext } from "../../context/AppContext";
import { useParams } from "react-router-dom";
import MainCard from "../../components/MainCard";
import APIReport from "./APIReport";
import WebMobileReport from "./WebMobileReport";

const TestCases = (props) => {
  const {
    getAllTestCases,
    iteration,
    getIteration,
    user,
    getUser,
    project,
    getProject,
    organization,
    getOrganization,
    loggedInUser,
  } = useAppContext();
  const { organizationId, userId, projectId, iterationId } = useParams();

  useEffect(() => {
    (async () => {
      if (!organization) await getOrganization(organizationId);
      if (userId !== loggedInUser?._id && !user) await getUser(userId);
      if (!project) await getProject(userId, projectId);
      if (!iteration) await getIteration(projectId, iterationId);
      await getAllTestCases(iterationId);
    })();
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainCard title="Dashboard" content={false}></MainCard>
      </Grid>
      {iteration?.testType === "API" ? <APIReport /> : <WebMobileReport />}
    </Grid>
  );
};

export default TestCases;
